import { ReactElement } from 'react'
import { Button, Image, Text } from '../../Atoms'
import Flex from '../Flex'
import { ChoiceDialogProps } from './props'
import { StyledChoiceDialog } from './styles'

const ChoiceDialog = ({
    icon,
    text,
    buttons,
    ...props
}: ChoiceDialogProps): ReactElement => {
    const arrayOfButton = buttons.map((button, i) => (
        <Button onClick={button.onClick} key={i}>
            {button.text}
        </Button>
    ))

    return (
        <StyledChoiceDialog {...props}>
            <Flex alignItems="center" gap="8">
                <Image src={icon} />
                <Text primary bold>
                    {text}
                </Text>
            </Flex>
            <Flex alignItems="center" gap="8">
                {arrayOfButton}
            </Flex>
        </StyledChoiceDialog>
    )
}

export default ChoiceDialog

export { StyledChoiceDialog }
